"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Sections;
(function (Sections) {
    Sections["repuve"] = "repuve";
    Sections["rapi"] = "rapi";
    Sections["rug"] = "rug";
    Sections["amis"] = "amis";
    Sections["criticalTax"] = "criticalTax";
    Sections["criticalInfraction"] = "criticalInfraction";
    Sections["noCriticalTax"] = "noCriticalTax";
    Sections["noCriticalInfraction"] = "noCriticalInfraction";
    Sections["tax"] = "tax";
    Sections["infraction"] = "infraction";
    Sections["theft"] = "theft";
})(Sections || (Sections = {}));
exports.default = Sections;
